import React from 'react';
import PropTypes from 'prop-types';
import ErrorDisplay from '../shared/errorDisplay';

const VideoUploadFieldset = props => {
  const errorOutput = {
    'no-video': props.translations['please-add-video'],
    'filesize-exceeded': props.translations['filesize-exceeded'],
    'general-video': props.translations['upload-error-general'],
  };
  const showError = Object.prototype.hasOwnProperty.call(
    errorOutput,
    props.error,
  );

  return (
    <fieldset className="video-fieldset">
      <div className="video-title">
        <p className="desc">{props.translations['title-video']}</p>
        {props.error === 'required' && (
          <ErrorDisplay errorMessage={props.translations['this-is-required']} />
        )}
        <div>
          <input type="text" name="title" required />
        </div>
      </div>
      <div>
        {showError && <ErrorDisplay errorMessage={errorOutput[props.error]} />}
        <div className="camcorder">
          {props.videoFileName ? (
            <span className="filename">{props.videoFileName}</span>
          ) : (
            <span>{props.translations['add-video']}</span>
          )}
          <input
            id="upload"
            type="file"
            name="upload"
            accept="video/*"
            capture="camcorder"
            onChange={props.captureFileName}
            required
          />
        </div>
      </div>
      <button
        id="video-submit-button"
        type="submit"
        className={props.spinnerDisplay ? 'form-loading' : null}
        onClick={event => props.submitVideo(event)}
        style={{ backgroundColor: props.comment.program.color }}
      >
        {props.translations['upload-video']}
      </button>
    </fieldset>
  );
};

VideoUploadFieldset.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  comment: PropTypes.shape({
    program: PropTypes.shape({ color: PropTypes.string }),
  }).isRequired,
  submitVideo: PropTypes.func.isRequired,
  captureFileName: PropTypes.func.isRequired,
  spinnerDisplay: PropTypes.bool.isRequired,
  error: PropTypes.string,
  videoFileName: PropTypes.string,
};

VideoUploadFieldset.defaultProps = {
  error: '',
  videoFileName: '',
};

export default VideoUploadFieldset;
